import React, { useMemo } from "react";
import {
  Page,
  Text,
  View,
  Image,
  Document,
  StyleSheet,
} from "@react-pdf/renderer";

 const mixDate = (date = null, option = {} as any) => {
  let str = ''
  try {
    let d = new Date()
    if (date) {
      d = new Date(date)
    }
    const year = d.getFullYear()
    const month = (d.getMonth() + 1).toString().padStart(2, '0')
    const day = d.getDate().toString().padStart(2, '0')
    if (option.hour) {
      const hours = d.getHours().toString().padStart(2, '0')
      const minutes = d.getMinutes().toString().padStart(2, '0')

      str = `${day}${option.bass || '/'}${month}${option.bass || '/'}${year} ${hours}:${minutes}`
      return str
    }

    if (option.ishour) {
      let hour = d.getHours() as any
      let minute = d.getMinutes() as any
      if (hour < 10) {
        hour = `0${hour}`
      }
      if (minute < 10) {
        minute = `0${minute}`
      }
      str = `${hour}:${minute}`
      return str
    }

    if (option.month) {
      str = `${day}${option.bass || '-'}${month}`
      return str
    }
    if (option.year) {
      return year
    }

    str = `${day}${option.bass || '/'}${month}${option.bass || '/'}${year}`
  } catch (error) {
    str = `2${option.bass || '/'}2${option.bass || '/'}2022`
  }
  return str
}

interface BillingProps {
  orderDetail: any;
}

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    fontFamily: "Helvetica",
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: 16,
    marginBottom: 24,
    borderBottom: "1px solid #00000014",
  },
  headerLeft: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },
  logo: {
    width: 80,
  },
  titleLeft: {
    fontSize: 20,
    fontWeight: 600,
    color: "#0A2B4D",
  },
  titleRight: {
    fontSize: 20,
    fontWeight: 500,
    color: "rgba(0,0,0,0.3)",
  },
  infoBill: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    marginBottom: 40,
  },
  col: {
    width: "30%",
  },
  item: {
    marginBottom: 16,
  },
  titlev1: {
    color: "#000000A6",
  },
  detailBill: {
    flexDirection: "column",
    gap: 12,
    backgroundColor: "#00000005",
    padding: 16,
  },
  flexRow: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  total: {
    borderTop: "1px solid #00000014",
    paddingTop: 6,
  },
});

const BillingPDF: React.FC<BillingProps> = ({ orderDetail }) => {
  // ===== Tối ưu biến =====
  const packageInfo = orderDetail?.package || {};
  const customer = orderDetail?.customer || {};
  const content = packageInfo?.content || {};

  // Format ngày chỉ 1 lần
  const createdAt = useMemo(() => {
    if (!orderDetail?.created_at) return "";
    // Giữ format gốc từ API
    return orderDetail.created_at;
  }, [orderDetail]);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          <View style={styles.headerLeft}>
            <Image src="https://portal.bidai.vip/magicAI-logo 20(1).svg" style={styles.logo} />
            <Text style={styles .titleLeft}>{content.val1 || "Package"}</Text>
          </View>

          <Text style={styles.titleRight}>Invoice</Text>
        </View>

        {/* Info Bill */}
        <View style={styles.infoBill}>
          {/* Customer */}
          <View style={styles.col}>
            <View style={styles.item}>
              <Text style={styles.titlev1}>Customer</Text>
              <Text>{customer.fullname || "---"}</Text>
            </View>

            <View style={styles.item}>
              <Text style={styles.titlev1}>Account</Text>
              <Text>{customer.email || "---"}</Text>
            </View>
          </View>

          {/* Invoice info */}
          <View style={styles.col}>
            <View style={styles.item}>
              <Text style={styles.titlev1}>Invoice Number</Text>
              <Text>{orderDetail?.code || "---"}</Text>
            </View>

            <View style={styles.item}>
              <Text style={styles.titlev1}>Date Issued</Text>
              <Text>{mixDate(createdAt, { hour: false })}</Text>
            </View>
          </View>
        </View>

        {/* Details */}
        <View style={styles.detailBill}>
          <View style={styles.flexRow}>
            <Text>Membership Plan</Text>
            <Text>{content.val1 || "N/A"}</Text>
          </View>

          <View style={styles.flexRow}>
            <Text>Duration</Text>
            <Text>
              {packageInfo.is_lifetime === 1
                ? "Lifetime"
                : packageInfo.day
                ? `${packageInfo.day} days`
                : "---"}
            </Text>
          </View>

          <View style={[styles.flexRow, styles.total]}>
            <Text>Amount</Text>
            <Text>${orderDetail?.total || 0} USD</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default BillingPDF;
